"use client";

import React from "react";
import { BrainCircuit, Headset, ShieldCheck, Wrench, Truck, MonitorSmartphone, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "SOIL ANALYSIS",
  description: "Comprehensive testing of soil composition and load-bearing capacity for structural integrity.\n\xA0Detailed reports for residential and commercial development",
  icon: BrainCircuit,
  link: "/ServicesPage"
}, {
  title: "GEOTECHNICAL DRILLING",
  description: "Precision subsurface exploration and sampling using state-of-the-art drilling rigs.\n\xA0Expert monitoring for accurate depth profiles\n\xA0Strata identification and sampling",
  icon: Wrench,
  link: "/ServicesPage"
}, {
  title: "ENVIRONMENTAL ASSESSMENTS",
  description: "Phase I and II site evaluations to ensure regulatory compliance and safety.\n\xA0Rigorous testing for soil contamination\n\xA0Groundwater quality parameters",
  icon: ShieldCheck,
  link: "/ServicesPage"
}, {
  title: "FOUNDATION DESIGN",
  description: "Engineering solutions for stable structures based on site-specific geological data.\n\xA0Optimized recommendations for deep and shallow foundation systems",
  icon: MonitorSmartphone,
  link: "/ServicesPage"
}, {
  title: "SITE INVESTIGATION",
  description: "Detailed mapping and characterization of ground conditions for construction planning.\n\xA0Utilizing advanced geophysical techniques for comprehensive site data",
  icon: Truck,
  link: "/ServicesPage"
}, {
  title: "CONSULTATION SERVICES",
  description: "Expert technical guidance throughout the project lifecycle.\n\xA0Professional oversight to mitigate geological risks\n\xA0Project feasibility assessments",
  icon: Headset,
  link: "/ServicesPage"
}];
export default function INostriServizi() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}